import ProductSupport from '@elem/compCommon/ProductConstructor/Support';
import { useEffect, useState } from 'react';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import { generalKeys } from '../../config/page';
import getProductSupport from '../../context/getSupport';
import css from './index.module.scss';
import { Spin } from 'antd';

export default function Support({ supportData, theme, productMsg }: any) {
    const [active, setActive] = useState(generalKeys[0]);
    const len = generalKeys?.length || 0;

    const [supportActive, setSupportActive] = useState('faq');
    const tabs: EcoTabItemProps[] = generalKeys.map((generalKey: string) => ({
        tabLabel: productMsg[generalKey]?.name || generalKey || '',
        tabValue: generalKey,
    }));

    const _getActiveFolder = (curSupportData: any) => {
        const { faqList = [], videoList = [] } = curSupportData;
        if (faqList?.length > 0) {
            return 'faq';
        } else if (videoList?.length > 0) {
            return 'tutorial';
        } else {
            return 'manuals';
        }
    };

    const handleTabChange = (_: any, k: number) => {
        setActive(generalKeys[k]);
        if (supportData[generalKeys[k]]) {
            setSupportActive(_getActiveFolder(supportData[generalKeys[k]]));
        }
    };

    useEffect(() => {
        if (supportData && supportData[active]) {
            setSupportActive(_getActiveFolder(supportData[active]));
        }
    }, [supportData, active]);

    return (
        <div className={`support ${css.support}`}>
            {len > 0 ? (
                <>
                    {len > 1 && len === tabs?.length && (
                        <div className="tab-sticky-box" style={{ backgroundColor: theme }}>
                            <EcoTab items={tabs} activeKey={tabs[0].tabValue} onChange={handleTabChange} theme={theme} />
                        </div>
                    )}
                    {supportData && supportData[active] && productMsg[active].spuId ? (
                        <ProductSupport supportActive={supportActive} supportData={supportData[active]} theme={theme} spuId={productMsg[active].spuId} />
                    ) : (
                        <>
                            {getProductSupport(active)}
                            <Spin />
                        </>
                    )}
                </>
            ) : (
                <>
                    {getProductSupport(active)}
                    <Spin />
                </>
            )}
        </div>
    );
}
